import { authGet } from "@api";
import { Organization } from "@types";

export const fetchOrganization = (
  organizationId: number
): Promise<Organization> => {
  return authGet<{ organization: Organization }>(
    `/api/agent/organizations/${organizationId}`
  ).then((result) => result.organization);
};
